module.exports = __webpack_public_path__ + "img/logo.d28bc8eb.svg";